export const API_URL = process.env.VUE_APP_API_URL + 'api/';
export const BASE_URL = process.env.VUE_APP_API_URL;
export const VERSION = 'v1/trekking-system';
export const API_VERSION = 'v1';
export const CLIENT_SECRET = process.env.VUE_APP_API_SECRET

export default {
    oauth: {
        grant_type: 'password',
        client_id: 2,
        client_secret: CLIENT_SECRET,
        scope: '*'
    },
    oauth_type: 'Bearer'
}
